module.exports = __webpack_public_path__ + "static/logo-dcf2563efdef107b2e44bdb62d199e1f.png";